module.exports = __webpack_public_path__ + "static/media/map icon.4382751a.svg";